import { NgModule } from '@angular/core';

import { KeysPipe } from './keys/keys';

@NgModule({
  declarations: [KeysPipe],
  exports: [KeysPipe],
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts